import { render, staticRenderFns } from "./FoodClient.vue?vue&type=template&id=175d9f76&scoped=true"
import script from "./FoodClient.vue?vue&type=script&lang=js"
export * from "./FoodClient.vue?vue&type=script&lang=js"
import style0 from "./FoodClient.vue?vue&type=style&index=0&id=175d9f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175d9f76",
  null
  
)

export default component.exports